module.exports = __webpack_public_path__ + "static/media/font_bold.deac45c4.woff2";